export enum TopicsDataQASelector {
  VIEW_ALL = "view-all-open-taxonomy-modal",
  CLOSE_MODAL = "close-taxonomy-modal",
  CANCEL_MODAL = "cancel-taxonomy-modal",
  APPLY_MODAL = "apply-taxonomy-modal",
  SEARCH_TAXONOMY = "search-taxonomy-modal",
  SELECT_TAXONOMY_LEVEL = "select-taxonomy-option-level-",
  SELECT_MAIN_TAXONOMY = "select-main-taxonomy-option",
  SELECT_TOPIC = "select-topic-filter",
}
